import React, { FC } from 'react';
import { FormikHelpers } from 'formik';
import OptionList from '../../../../library/inputs/optionlist/OptionList';

interface Props {
  id: string;
  value: Array<string>;
  options: { text: JSX.Element | string; value: string }[] | undefined;
  setFieldTouched: FormikHelpers<string>['setFieldTouched'];
  setFieldValue: FormikHelpers<string>['setFieldValue'];
  multiSelection: boolean | undefined;
  readOnlyMode?: boolean;
  culture?: string;
}

const OptionListField: FC<Props> = ({
  id,
  value,
  options,
  setFieldTouched,
  setFieldValue,
  multiSelection,
  readOnlyMode,
}: Props) => {
  return (
    <OptionList
      value={value}
      options={options}
      multiSelection={multiSelection}
      onChange={async (val) => {
        await setFieldValue(id, val, true);
        await setFieldTouched(id, true, true);
      }}
      readOnlyMode={readOnlyMode}
    />
  );
};

export default OptionListField;
